import { isHiddenToolCall } from '../agentInsightsUtils';
import { decodeMessageContent } from '../internal/conversation/decodeMessageContent';
import { normalizeToolName, toolProgressLabel } from '../internal/toolProgressLabel';

import type { ConversationMessage } from './pickFinalReply';

export type ToolActivity = {
  id: string;
  name: string;
  label: string;
  messageIndex: number;
  done: boolean;
};

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export function readToolActivity(messages: ConversationMessage[]): ToolActivity[] {
  const activity: ToolActivity[] = [];
  const byToolUseId = new Map<string, ToolActivity>();

  messages.forEach((message, messageIndex) => {
    if (message.role !== 'assistant') {
      return;
    }
    const decoded = decodeMessageContent(message.content);
    if (!decoded || !Array.isArray(decoded.content)) {
      return;
    }
    decoded.content.forEach((block: unknown, blockIndex) => {
      if (!isRecord(block)) {
        return;
      }
      if (block.type === 'tool_use' && typeof block.name === 'string' && block.name) {
        const name = normalizeToolName(block.name);
        if (isHiddenToolCall(name)) {
          return;
        }
        const toolUseId = typeof block.id === 'string' && block.id ? block.id : undefined;
        const item: ToolActivity = {
          id: toolUseId ? `tool:${toolUseId}` : `${message.id ?? messageIndex}:${blockIndex}`,
          name,
          label: toolProgressLabel(name),
          messageIndex,
          done: false,
        };
        if (toolUseId) {
          if (byToolUseId.has(toolUseId)) {
            return;
          }
          byToolUseId.set(toolUseId, item);
        }
        activity.push(item);
        return;
      }
      if (block.type === 'tool_result' && typeof block.tool_use_id === 'string') {
        const item = byToolUseId.get(block.tool_use_id);
        if (item) {
          item.done = true;
        }
      }
    });
  });

  return activity;
}
